import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { IMovieHeaderProps } from 'typings/IMovieHeaderProps';
import OverviewModel from 'models/overview.model';
import PromotionCollectionQuery from 'queries/overview/overviewPromotionCollection.query';
import { PROMO_QUERY_CLIENT, PROGRAM } from '../../../constants';
import ErrorBoundary from '../../ErrorBoundary';
import PromoImageHeading from '../../PromoImageHeading';
import PromoImageHeadingFallback from '../../PromoImageHeading/PromoImageHeadingFallback';
import { SkeletonPromoHeading } from '../../SkeletonElement/SkeletonElement';
import VideoHeading from '../../VideoHeading';

const FILMS_SLUG = 'films';

const MovieHeading = ({ videoId, viewMode, client }: IMovieHeaderProps): JSX.Element => {
  const [EditorialOverviewData, setEditorialOverview] = useState<OverviewModel | null>(null);

  const { loading, error } = useQuery(PromotionCollectionQuery, {
    variables: {
      slug: FILMS_SLUG,
      client: PROMO_QUERY_CLIENT.DESKTOP
    },
    onCompleted: (data: { overview?: IEditorialOverviewData }) => {
      if (data?.overview) {
        const editorialOverview = new OverviewModel(data.overview, { isOnFormatPage: false });
        setEditorialOverview(editorialOverview.isValid ? editorialOverview : null);
      }
    }
  });

  if (videoId) {
    return <VideoHeading viewMode={viewMode} client={client} videoGuid={videoId} videoType={PROGRAM.MOVIE} />;
  }

  if (loading && !EditorialOverviewData) return <SkeletonPromoHeading />;

  if (!loading && (!EditorialOverviewData?.headerPromotion || error)) {
    return <PromoImageHeadingFallback />;
  }

  const promotions = EditorialOverviewData && EditorialOverviewData.headerPromotion?.promotions;
  if (!promotions || !promotions.length || !promotions[0].program) return <PromoImageHeadingFallback />;

  const { program, description, imageMediaId } = promotions[0];
  const Path =
    program.type === PROGRAM.MOVIE
      ? `/films/${program.slug}/${program.guid}`
      : `/programmas/${program.series?.slug}/${program.guid}`;
  const moviePromoDescription = description || program.shortDescription;

  return (
    <ErrorBoundary onError={(_: any) => <PromoImageHeadingFallback />}>
      <PromoImageHeading
        path={Path}
        promoGuid={program.guid}
        title={program.title}
        imageMediaId={imageMediaId}
        type={program.type}
        description={moviePromoDescription}
        viewMode={viewMode}
        metadata={program.metadata}
      />
    </ErrorBoundary>
  );
};

export default MovieHeading;
